import { CorpType, isMydataOrgCode, getKeyByMydataOrgCode, isFucCode, getKeyByFucCode, isDictName, getKeyByName, isBankKey, isCardKey, isCapitalKey, isInsuranceKey, isInvestKey, isPointKey, isSavingBankKey, isTelecomKey } from '@financial/asset-constants';
import '../../../share/constants/dist/index.mjs';
import { BiScheme } from '../constants/scheme.mjs';

const loggingOnlyDev = message => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(message);
  }
};
const getBiInfoFromProps = _ref => {
  let {
    mydataOrgCode,
    corpId,
    name
  } = _ref;
  if (mydataOrgCode) {
    if (isMydataOrgCode(mydataOrgCode)) {
      const key = getKeyByMydataOrgCode(mydataOrgCode);
      return {
        key,
        scheme: BiScheme[key]
      };
    }
    loggingOnlyDev(`${mydataOrgCode}는 올바른 마이데이터 코드가 아닙니다.`);
  }
  if (corpId) {
    if (isFucCode(corpId)) {
      const key = getKeyByFucCode(corpId);
      return {
        key,
        scheme: BiScheme[key]
      };
    }
    loggingOnlyDev(`${corpId}는 올바른 금융결제원 코드가 아닙니다.`);
  }
  if (name) {
    if (isDictName(name)) {
      const key = getKeyByName(name);
      return {
        key,
        scheme: BiScheme[key]
      };
    }
    loggingOnlyDev(`${name}으로 금융사를 찾을 수 없습니다.`);
  }
  return null;
};
const calculateSize = _ref2 => {
  let {
    defaultWidth,
    defaultHeight,
    propWidth,
    propHeight
  } = _ref2;
  if (propHeight) {
    return {
      width: Math.round(propHeight * defaultWidth / defaultHeight),
      height: propHeight
    };
  }
  if (propWidth) {
    return {
      width: propWidth,
      height: Math.round(propWidth * defaultHeight / defaultWidth)
    };
  }
  return {
    width: defaultWidth,
    height: defaultHeight
  };
};
const getCorpType = key => {
  if (isBankKey(key)) {
    return CorpType.BANK;
  }
  if (isCardKey(key)) {
    return CorpType.CARD;
  }
  if (isCapitalKey(key)) {
    return CorpType.CAPITAL;
  }
  if (isInsuranceKey(key)) {
    return CorpType.INSURANCE;
  }
  if (isInvestKey(key)) {
    return CorpType.INVEST;
  }
  if (isPointKey(key)) {
    return CorpType.POINT;
  }
  if (isSavingBankKey(key)) {
    return CorpType.SAVING_BANK;
  }
  if (isTelecomKey(key)) {
    return CorpType.TELECOM;
  }
  return CorpType.BANK;
};
function getCDNOrigin() {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  return "https://financial.pstatic.net/pie" ;
}
function getCDNPath() {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  return "/common-bi/1.22.0" ;
}
function getCDNImageUrl(src) {
  const url = getCDNOrigin();
  return `${url}${getCDNPath()}/images/${src}.png`;
}
const getBackgroundImage = prop => {
  const found = getBiInfoFromProps(prop);
  if (!found) {
    return null;
  }
  return found.scheme.backgroundImage;
};
const getBackgroundColor = prop => {
  const found = getBiInfoFromProps(prop);
  if (!found) {
    return null;
  }
  return found.scheme.backgroundColor;
};
const hasPlateBi = prop => {
  const found = getBiInfoFromProps(prop);
  if (!found) {
    return false;
  }
  return 'plateTextSize' in found.scheme;
};
const getCorpTypeByBiId = biId => {
  const biInfo = getBiInfoFromProps(biId);
  if (!biInfo) {
    return null;
  }
  return getCorpType(biInfo.key);
};
const isBank = biId => getCorpTypeByBiId(biId) === CorpType.BANK;
const isInvest = biId => getCorpTypeByBiId(biId) === CorpType.INVEST;
const isCard = biId => getCorpTypeByBiId(biId) === CorpType.CARD;
const isSavingBank = biId => getCorpTypeByBiId(biId) === CorpType.SAVING_BANK;
const isInsurance = biId => getCorpTypeByBiId(biId) === CorpType.INSURANCE;
const isCapital = biId => getCorpTypeByBiId(biId) === CorpType.CAPITAL;
const isTelecom = biId => getCorpTypeByBiId(biId) === CorpType.TELECOM;
const isPoint = biId => getCorpTypeByBiId(biId) === CorpType.POINT;

export { calculateSize, getBackgroundColor, getBackgroundImage, getBiInfoFromProps, getCDNImageUrl, getCorpType, getCorpTypeByBiId, hasPlateBi, isBank, isCapital, isCard, isInsurance, isInvest, isPoint, isSavingBank, isTelecom };
